import { envelopeImage } from "assets";
import { Modal } from "components";

interface EmailValidationModalProps {
  show: boolean;
  close: () => void;
  onResend?: () => void;
  resending?: boolean;
}

const EmailValidationModal: React.FC<EmailValidationModalProps> = ({
  show,
  close,
  onResend,
  resending,
}) => {
  return (
    <>
      <Modal
        position={"centered"}
        close={close}
        show={show}
        contentClassName='bg-white !overflow-visible !max-w-[500px]'
      >
        <div className="flex justify-center mb-6">
          <div className={`w-[130px] h-[130px] -mt-[80px] rounded-full grid place-content-center overflow-hidden`}>
            <img src={envelopeImage} alt="icon " className={`object-cover w-[150px] h-[150px] rounded-full`} />
          </div>
        </div>

        <h2 className={`text-3xl font-bold text-center mb-4 text-[#012169]`}>
          Email Verification
        </h2>

        <p className={`text-center mb-8 sm:w-[70%] mx-auto text-[#344054]`}>
          Click the received link in your email to verify your Email.<b> Also check your spam section</b>
        </p>

        {/* Buttons */}
        <div className="flex gap-5 sm:w-[80%] mx-auto mb-6">
          <button
            onClick={close}
            className={`flex-1 py-3 px-6 rounded-[4px] font-medium transition-colors bg-white hover:bg-white/30 text-[#344054] ml-0 !border border-[#98A2B3]`}
          >
            Close
          </button>
          <button
            onClick={onResend}
            disabled={!onResend || resending}
            className={`flex-1 py-3 px-6 rounded-[4px] font-medium transition-colors bg-[#012169] hover:bg-[#012169]/60 text-white text-center disabled:opacity-60 disabled:cursor-not-allowed`}
          >
            {resending ? "Resending..." : "Resend verification"}
          </button>
        </div>
      </Modal>
    </>
  );
};

export { EmailValidationModal };
